import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Simple, explicit eventing system.
 *
 * @returns {registerHandler}
 */
export function createNotifier() {
  var registrations = [];
  function registerHandler(fn) {
    registrations = [].concat(_toConsumableArray(registrations), [fn]);
    return function unregisterHandler() {
      registrations = registrations.filter(function (x) {
        return x !== fn;
      });
    };
  }
  function notify() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    registrations.forEach(function (fn) {
      return fn.apply(void 0, args);
    });
  }
  registerHandler.notify = notify;
  return registerHandler;
}
//# sourceMappingURL=notifier.js.map
